import Textarea from "app/components/Icons/Textarea";
import Input from "app/components/Input";
import Modal from "app/components/Modal";
import { selectUserFormData } from "app/redux/selector";
import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectDraftBoardForm } from "../../../components/Settings/redux/selector";
import { useBoardsActions } from "../../../components/useBoardsActions";
import { selectGroupForm } from "../../Tickets/redux/selector";
import { ticketGroupsActions } from "../../Tickets/redux/slice";
import { v4 as uuid } from "uuid";
interface AddTicketGroupModalProps {
  onClose: () => void;
  isEditGroup: boolean;
  onSave?: (name: string, description: string) => void;
  modalClassName?: string;
  insetClassName?: string;
}

export default function AddTicketGroupModal({
  onClose,
  isEditGroup,
  onSave,
  modalClassName,
  insetClassName,
}: AddTicketGroupModalProps) {
  const dispatch = useDispatch();
  const groupForm = useSelector(selectGroupForm);
  const { _id: boardId } = useSelector(selectDraftBoardForm);
  const { selectedProjectId } = useSelector(selectUserFormData);
  const { updateBoardsGroupsJson } = useBoardsActions(selectedProjectId);

  useEffect(() => {
    if (!isEditGroup) {
      dispatch(
        ticketGroupsActions.setGroupFormValues({ name: "name", value: "" }),
      );
      dispatch(
        ticketGroupsActions.setGroupFormValues({
          name: "description",
          value: "",
        }),
      );
    }
  }, [dispatch, isEditGroup]);

  const isDisabled = useCallback(() => {
    if (groupForm.name.value === "") {
      return true;
    }
    return false;
  }, [groupForm.name.value]);

  const handleAddGroup = () => {
    if (onSave) {
      onSave(groupForm.name.value, groupForm.description.value);
      dispatch(
        ticketGroupsActions.setGroupFormValues({ name: "name", value: "" }),
      );
      dispatch(
        ticketGroupsActions.setGroupFormValues({
          name: "description",
          value: "",
        }),
      );
    } else {
      const newGroup = {
        _id: uuid(),
        name: groupForm.name.value ?? "",
        description: groupForm.description.value ?? "",
        isCollapse: false,
        isVisible: true,
        ticketLimit: 0,
        tickets: [],
        ticketsList: [],
        order: 0,
        subGroups: [],
      };
      dispatch(ticketGroupsActions.addNewCustomGroup(newGroup));
      updateBoardsGroupsJson(boardId, () => {
        onClose();
      });
    }

    // dispatch(ticketGroupsActions.createTicketGroup());
  };

  return (
    <Modal
      onClose={onClose}
      submitText="Save"
      isSubmitDisabled={isDisabled()}
      onSubmit={() => {
        handleAddGroup();
      }}
      title={`${isEditGroup ? " Edit group" : "Add new group"}`}
      contentClassName="!p-0"
      modalClassName={`max-w-[400px] ${modalClassName}`}
      insetClassName={insetClassName}
    >
      <div className="flex flex-col px-[24px] py-4 pt-[12px] gap-4">
        <div className="flex flex-col gap-y-4">
          <Input
            placeholder="Enter group name"
            id="name"
            name="name"
            inputClassName="!h-[48px] !gap-[0px]"
            innerContainerClassName="!gap-[0px]"
            value={groupForm.name.value}
            error={groupForm.name.error}
            onChange={(e) => {
              dispatch(
                ticketGroupsActions.setGroupFormValues({
                  name: e.target.name,
                  value: e.target.value,
                }),
              );
            }}
          />
          <Textarea
            placeholder="Group description"
            id="description"
            name="description"
            inputClassName="!gap-[0px]"
            innerContainerClassName="!gap-[0px]"
            value={groupForm.description.value}
            error={groupForm.description.error}
            maxLength={100}
            onChange={(e) => {
              dispatch(
                ticketGroupsActions.setGroupFormValues({
                  name: e.target.name,
                  value: e.target.value,
                }),
              );
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
